import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type { AppNotification, NotificationListFilters } from './types';

export const notificationApi = {
  list: (params?: NotificationListFilters) =>
    tenantApi.getPaginated<AppNotification>('/notifications', { params }),

  unreadCount: () =>
    tenantApi.getOne<{ count: number }>('/notifications/unread-count'),

  markRead: (id: string) =>
    tenantApi.postOne<AppNotification>(`/notifications/${id}/read`),

  markAllRead: () =>
    tenantApi.postOne<{ ok: boolean }>('/notifications/read-all'),
};
